/* Copyright (c) 2026 Xperi. All Rights Reserved. */

/**
 * Feature Activation Framework — the single source of truth for feature
 * metadata. Callers ask `isFeatureEnabled(feature)` and never encode
 * feature-specific activation rules themselves; this table owns them.
 *
 * Service mappings follow the real device-feature payload conventions:
 *   - boolean attribute:  `transactionsEnabled` → attribute `transactionsEnabled`
 *   - feature presence:   `enablePreviewPlayer` (no attribute) — present ⇒ on
 *
 * Type/stage/service assignments here are the framework's initial wiring and
 * can be revised per feature without touching any caller.
 */

import {
  Feature,
  FeatureServiceSource,
  FeatureStage,
  FeatureType
} from "./types";
import type { TFeatureDefinition } from "./types";

export const featureRegistry: Readonly<Record<Feature, TFeatureDefinition>> = {
  [Feature.NPVR_RECORDING]: {
    type: FeatureType.SERVICE_CONTROLLED,
    stage: FeatureStage.RELEASED,
    serviceFeature: {
      source: FeatureServiceSource.NPVR,
      defaultEnabled: false
    }
  }
};

/** Registered features in declaration order — drives the debug screen list. */
export const registeredFeatures: ReadonlyArray<Feature> = Object.keys(
  featureRegistry
) as Array<Feature>;
